
























































import Vue, { PropOptions } from 'vue';
import dayjs from 'dayjs';
import { Team, Campaign } from '@/models';

export default Vue.extend({
  props: {
    campaign: {
      type: Object,
    },
    teams: Array,
  },
  computed: {
    formatScheduledTo() {
      if (
        (this.campaign as any).scheduledTo &&
        (this.campaign as any).scheduledTo.iso
      ) {
        return dayjs(this.campaign.scheduledTo.iso).format('DD MMM YYYY HH:mm');
      }
      return 'Sem agendamento';
    },
    redirectedTeam() {
      const found = this.teams && (this.teams as Team[]).find((t) => (
        t.objectId === ((this.campaign as Campaign).routeReplies as any).objectId
      ));
      return found && found.name;
    },
  },
});
